"use strict";
/**
 *
 * Datadog Browser Logs SDK for collecting and forwarding browser logs to Datadog.
 * Provides comprehensive logging capabilities with automatic error tracking and custom log collection.
 *
 * @packageDocumentation
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogLogs = exports.StatusType = exports.HandlerType = exports.Logger = void 0;
const browser_core_1 = require("@datadog/browser-core");
const logsPublicApi_1 = require("../boot/logsPublicApi");
const startLogs_1 = require("../boot/startLogs");
var logger_1 = require("../domain/logger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
Object.defineProperty(exports, "HandlerType", { enumerable: true, get: function () { return logger_1.HandlerType; } });
var isAuthorized_1 = require("../domain/logger/isAuthorized");
Object.defineProperty(exports, "StatusType", { enumerable: true, get: function () { return isAuthorized_1.StatusType; } });
/**
 * The global Logs instance. Use this to call Logs methods.
 *
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */
exports.datadogLogs = (0, logsPublicApi_1.makeLogsPublicApi)(startLogs_1.startLogs);
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_LOGS', exports.datadogLogs);
//# sourceMappingURL=main.js.map